import useStableObjectReference from 'hooks/useStableObjectReference'
import usePrevious from 'hooks/usePrevious'
import { hasFilterChanged } from 'lib/offer/hasFilterChanged'

function useFilterWasApplied(currentFilters: App.OfferListFilters): boolean {
  const stableFilters = useStableObjectReference(currentFilters)
  const previousFilters = usePrevious(stableFilters)

  if (!previousFilters) return false

  return hasFilterChanged({ currentFilters, previousFilters })
}

export default useFilterWasApplied
